import type { ReactElement } from "react";
import type { Permissions } from "../apiClient/generated";
import { useUser } from "../auth";

interface Props {
    permission: keyof Permissions;
    children: ReactElement;
    requiredFlag?: string;
}

export const PermissionGate = ({
    permission,
    children,
    requiredFlag,
}: Props) => {
    const { permissions, flags } = useUser();

    // TODO: Implement no permissions message page.
    if (requiredFlag && !flags.includes(requiredFlag)) {
        return null;
    }

    if (!permissions[permission]) {
        return null;
    }

    return children;
};
